module.exports = __webpack_public_path__ + "img/black.408e7f84.webp";